import React from 'react';
import { TabsContent } from "@/components/ui/tabs";
import LogoGrid from './LogoGrid';
import type { Logo } from '@/hooks/useLogos';

interface TabContentProps {
  value: string;
  logos: Logo[];
  emptyMessage: string;
  viewMoreLabel: string;
  showLessLabel: string;
}

const TabContent = ({ value, logos, emptyMessage, viewMoreLabel, showLessLabel }: TabContentProps) => {
  return (
    <TabsContent value={value} className="mt-8">
      {logos.length > 0 ? (
        <LogoGrid logos={logos} viewMoreLabel={viewMoreLabel} showLessLabel={showLessLabel} />
      ) : (
        <p className="text-center text-neutral-600">{emptyMessage}</p>
      )}
    </TabsContent>
  );
};

export default TabContent;